import axiosInstance from './axiosInstance';

export const getTablesByRestaurant = (restaurantGuid: string) =>
  axiosInstance.get(`/table/restaurant/${restaurantGuid}`);

export const createTable = (data: any) =>
  axiosInstance.post('/table', data);

export const updateTable = (id: string, data: any) =>
  axiosInstance.put(`/table/${id}`, data);

export const deleteTable = (id: string) =>
  axiosInstance.delete(`/table/${id}`);


// ✅ Get QR Image for a specific table
export const getQrImage = (restaurantGuid: string, tableId: string) =>
  axiosInstance.get(`/table/getQrImage`, {
    params: { restaurantGuid, tableId },
  });

// ✅ Save QR Image for a specific table
export const saveQrImage = (
  restaurantGuid: string,
  tableId: string,
  qrImage: string,
  themeName: string
) =>
  axiosInstance.post(`/table/saveQrImage`, {
    restaurantGuid,
    tableId,
    qrImage,
    themeName,
  });

// ✅ Save Customer Details
export const saveCustomerDetails = (data: {
  id?: string;
  tableId: string;
  customerName?: string;
  customerEmail?: string;
  customerMobile?: string;
  totalGuest?: number;
  waiterName?: string;
}) =>
  axiosInstance.post('/Auth/QuickServe/SaveCustomerDetails', data);